import { render, staticRenderFns } from "./BtnReferences.vue?vue&type=template&id=5f754acc&scoped=true&"
import script from "./BtnReferences.vue?vue&type=script&lang=js&"
export * from "./BtnReferences.vue?vue&type=script&lang=js&"
import style0 from "./BtnReferences.vue?vue&type=style&index=0&id=5f754acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f754acc",
  null
  
)

export default component.exports